import React from "react";

export const ItemContents = React.memo(function ItemContent(props: Props) {
    const { itemContents } = props;

    return (
        <ul className={"itemContents"}>
            {itemContents.map((value, index) => <li key={index}>{value}</li>)}
        </ul>
    );
});

type Props = {
    itemContents: string[]
}